import React, { useCallback, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import {
  AppDatePicker,
  AppInput,
  AppModal,
  AppRemixIcon,
} from "@/layout/AppComponents";
import axios from 'axios';
import { Formik } from 'formik';
import BtnOptions from './BtnOptions';
import { axiosPath } from '../../../../../routing/helpers/router';
import Translator from '../../../../components/helpers/Translator';
import AppTextEditor from '../../../../components/form/Texts/AppTextEditor';

const Report51Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;

  const [modeEdit, setModeEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const changeComment = useCallback(async (formikValues) => {
    setIsLoading(true);

    await axios
      .post(axiosPath("api_r_user_module_intelligence_changeComment"), {
        intelligenceReport: values?.report?.value,
        payload: {
          comment: formikValues?.comment,
        },
      })
      .then(({ data }) => {
        const { comment } = data;
        values.report.comment = comment;
      })
      .finally(() => {
        setIsLoading(false);
        setModeEdit(false);
      });
  }, [values]);

  return (
    <>
      <div className="row align-items-center">
        <div className="col">
          <AppInput
            icon={<AppRemixIcon icon="fingerprint" />}
            title={
              <Translator
                file="module-intelligence"
                name="obligations"
              />
            }
            placeholder={
              <Translator
                file="module-intelligence"
                name="comma-separated-obligation-ids"
              />
            }
            value={values?.obligations ?? ''}
            onChange={(value) =>
              handleOnSetFieldValue(
                'obligations',
                value.replace(/[^0-9a-fA-F,]/, '')
              )
            }
            isClearable
          />
        </div>
        <div className="col-auto d-flex justify-content-center">
          <span
            onClick={() => setShowModal(true)}
            className="btn btn-primary d-inline-flex align-items-center justify-content-center p-0"
            style={{ width: '2.25rem', height: '2.25rem' }}
          >
            <AppRemixIcon
              icon="question-line"
              className="pointer"
              size={16}
              title={ReactDOMServer.renderToString(
                <Translator file="admin" name="general.clients" />
              )}
              noVariants
            />
          </span>
          <AppModal
            title="Descripción"
            show={showModal}
            onClose={() => setShowModal(false)}
            cancelBtnText={ReactDOMServer.renderToString(
              <Translator file="user" name="general.close" />
            )}
            size="xl"
          >
            <Formik
              initialValues={{
                comment: values.report?.comment
              }}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={changeComment}
            >
              {({ setFieldValue, handleSubmit, values: formikValues }) => (
                <div>
                  {
                    modeEdit ? (
                      <div>
                        <div style={{ minHeight: '6rem' }}>
                          <AppTextEditor
                            value={formikValues.comment}
                            onChange={(opt) => setFieldValue('comment', opt)}
                            toolbar={{
                              toolbar: [['bold', 'italic']],
                            }}
                            height={200}
                          />
                        </div>
                        <hr />
                        <div className="col-12 d-flex justify-content-between">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            disabled={isLoading}
                            onClick={() => setModeEdit(false)}
                          >
                            <Translator
                              file="user"
                              name="user.cancel"
                            />
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isLoading}
                            onClick={handleSubmit}
                          >
                            <Translator
                              file="module-intelligence"
                              name="accept-changes"
                            />
                          </button>
                        </div>
                      </div>
                    )
                      : (
                        <div>
                          <div
                            style={{ minHeight: '6rem' }}
                            dangerouslySetInnerHTML={{
                              __html: formikValues.comment
                            }}
                          />
                          <hr />
                          <div className="col-12 d-flex justify-content-between">
                            <span onClick={() => setModeEdit(true)} className="btn btn-outline-primary">
                              <Translator
                                file="general"
                                name="general.edit"
                              />
                            </span>
                            <button
                              type="button"
                              className="btn btn-primary"
                              disabled={isLoading}
                              onClick={() => {
                                setModeEdit(false);
                                setShowModal(false);
                              }}
                            >
                              <Translator
                                file="module-legalCompliance"
                                name="close"
                              />
                            </button>
                          </div>
                        </div>
                      )
                  }

                </div>
              )}
            </Formik>
          </AppModal>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator
                file="module-intelligence"
                name="date1"
              />
            }
            value={values.date1}
            onChange={(date) => handleOnSetFieldValue('date1', date)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator
                file="module-intelligence"
                name="date2"
              />
            }
            value={values.date2}
            onChange={(date) => handleOnSetFieldValue('date2', date)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-12">
              <BtnOptions
                isDisabled={
                  !values.obligations || !values.date1 || !values.date2
                }
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report51Options;
